import { render } from "./HolidayEditAdd.vue?vue&type=template&id=2b72c868&scoped=true"
import script from "./HolidayEditAdd.vue?vue&type=script&lang=js"
export * from "./HolidayEditAdd.vue?vue&type=script&lang=js"

import "./HolidayEditAdd.vue?vue&type=style&index=0&id=2b72c868&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b72c868"]])

export default __exports__